import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = () => {
  // Check user object on refresh
  const userStr = localStorage.getItem("user");
  let user = null;
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch {
    user = null;
  }

  // If user is deleted, remove tokens and logout
  if (user && user.isDeleted === true) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    return <Navigate to="/" replace />;
  }

  const token = localStorage.getItem("token");

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (currentTime < decoded.exp) {
        console.log("Token is valid");
      } else {
        console.log("Token has expired");
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
      return currentTime > decoded.exp;
    } catch (error) {
      return true;
    }
  };

  if (!token || isTokenExpired(token) || !user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
